import React from 'react';
import { Star } from 'lucide-react';

// Average rating of a partner centre (stars + count); renders "Nouveau partenaire" when unrated
export const Stars = ({ value, size = 13, onChange, testId }) => (
  <span className="inline-flex items-center gap-0.5" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => (
      <Star key={n} size={size} onClick={onChange ? () => onChange(n) : undefined} data-testid={onChange ? `${testId}-${n}` : undefined}
        className={`${n <= Math.round(value || 0) ? 'fill-amber-400 text-amber-400' : 'text-gray-300'} ${onChange ? 'cursor-pointer hover:scale-110 transition-transform' : ''}`} />
    ))}
  </span>
);

const CentreRating = ({ rating, testId, className = '' }) => {
  if (!rating || !rating.count) return <span className={`text-[11px] text-gray-400 ${className}`} data-testid={testId}>Nouveau partenaire</span>;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] text-gray-700 ${className}`} data-testid={testId}>
      <Stars value={rating.avg} size={11} />
      <strong>{String(rating.avg).replace('.', ',')}</strong>
      <span className="text-gray-500">({rating.count} avis)</span>
    </span>
  );
};

export default CentreRating;
